"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo } from "react";
import Link from "next/link";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
interface WebSidebarExpandableGroupProps {
  readonly name: string;
  readonly items: ReadonlyArray<{
    name: string;
    href: string;
  }>;
  readonly pathname: string | null;
  readonly expanded: boolean;
  readonly onToggle: (isExpanded: boolean) => void;
}
function WebSidebarExpandableGroup(t0) {
  const $ = _c(30);
  const {
    name,
    items,
    pathname,
    expanded,
    onToggle
  } = t0;
  let t1;
  if ($[0] !== pathname) {
    t1 = href => pathname === href;
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isActive = t1;
  const hasActiveItem = items.some(item => isActive(item.href));
  let t2;
  if ($[2] !== expanded || $[3] !== onToggle) {
    t2 = () => {
      onToggle(!expanded);
    };
    $[2] = expanded;
    $[3] = onToggle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleToggle = t2;
  const t3 = `tw-w-[calc(100%-2.75rem)] tw-flex tw-items-center tw-no-underline tw-rounded-xl tw-border-none tw-transition-colors tw-duration-200 tw-cursor-pointer focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-iron-500 focus-visible:tw-ring-offset-2 tw-font-medium tw-pl-3 tw-pr-3 tw-ml-[2.75rem] tw-h-11 tw-justify-between tw-text-base tw-touch-action-manipulation ${hasActiveItem ? "tw-text-white tw-bg-iron-900 desktop-hover:hover:tw-text-white desktop-hover:hover:tw-bg-iron-900 active:tw-text-white" : "tw-text-iron-400 tw-bg-transparent desktop-hover:hover:tw-bg-transparent desktop-hover:hover:tw-text-white active:tw-text-white"}`;
  const t4 = `group-${name}`;
  let t5;
  if ($[5] !== name) {
    t5 = <span>{name}</span>;
    $[5] = name;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `tw-h-4 tw-w-4 tw-shrink-0 tw-transition-transform tw-duration-200 ${expanded ? "tw-rotate-90" : ""}`;
  let t7;
  if ($[7] !== t6) {
    t7 = <ChevronRightIcon className={t6} />;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== expanded || $[10] !== handleToggle || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t7) {
    t8 = <button type="button" onClick={handleToggle} className={t3} aria-expanded={expanded} aria-controls={t4}>{t5}{t7}</button>;
    $[9] = expanded;
    $[10] = handleToggle;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = `tw-grid tw-transition-[grid-template-rows] tw-duration-300 tw-ease-out ${expanded ? "tw-grid-rows-[1fr]" : "tw-grid-rows-[0fr]"}`;
  const t10 = `group-${name}`;
  let t11;
  if ($[16] !== isActive || $[17] !== items) {
    let t12;
    if ($[19] !== isActive) {
      t12 = item_0 => <Link key={item_0.name} href={item_0.href} className={`tw-w-[calc(100%-2.75rem)] tw-flex tw-items-center tw-no-underline tw-rounded-xl tw-border-none tw-transition-colors tw-duration-200 tw-cursor-pointer focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-iron-500 focus-visible:tw-ring-offset-2 tw-font-medium tw-justify-start tw-pl-3 tw-pr-3 tw-ml-[2.75rem] tw-h-11 tw-text-base tw-touch-action-manipulation ${isActive(item_0.href) ? "tw-text-white tw-bg-iron-900 desktop-hover:hover:tw-text-white desktop-hover:hover:tw-bg-iron-900 active:tw-text-white" : "tw-text-iron-400 tw-bg-transparent desktop-hover:hover:tw-bg-transparent desktop-hover:hover:tw-text-white active:tw-text-white"}`} aria-current={isActive(item_0.href) ? "page" : undefined}>{item_0.name}</Link>;
      $[19] = isActive;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    t11 = items.map(t12);
    $[16] = isActive;
    $[17] = items;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <div className="tw-overflow-hidden"><div id={t10} className="tw-mt-1">{t11}</div></div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t9) {
    t13 = <div className={t9}>{t12}</div>;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t8) {
    t14 = <div>{t8}{t13}</div>;
    $[27] = t13;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
}
export default React.memo(WebSidebarExpandableGroup);